import React from "react";

import "../Button/Button.css";

function Button() {
  return (
    <button className="container_btn">
      <i className="fas fa-arrow-left"></i> Back off
    </button>
  );
}

export default Button;
